import { gql } from '@apollo/client';
import { USER } from '../fragments';

export const ARCHIVE_USER = gql`
  mutation archiveUser($id: ID!) {
    user: archiveUser(id: $id) {
      ...user
    }
  }
  ${USER}
`;
